// TODO: Doesn't show products have been added to wishlist

// Override Settings
var bcSfFilterSettings = {
    general: {
      limit: 48,
      /* Optional */
      // loadProductFirst: true,
      enableKeepScrollbackPosition: true,
      paginationTypeAdvanced: true,
      paginationType: $(window).innerWidth() > 767 ? 'load_more' : 'infinite',
    }
};

// Declare Templates
var bcSfFilterTemplate = {
    'soldOutClass': 'sold-out',
    'soldOutLabelHtml': '<div class="wmwproduct-grid__soldout"><span>' + bcSfFilterConfig.label.sold_out + '</span></div>',
    'vendorHtml': '<div>{{itemVendorLabel}}</div>',

    // Grid Template
    'productGridItemHtml': 
        '<div class="wmwgrid__item wmwgrid__one-quarter {{wrapperClasses}}{{hidden}}" id="{{itemId}}" data-page="{{page}}"><a href="{{itemUrl}}" class="product-grid--link" ></a>' +
            '<div class="wmwproduct-grid {{soldOutClass}} {{saleClass}}" data-handle="{{itemHandle}}" data-mh="product-figure"><div class="thumb-box">' +
                '<a href="{{itemUrl}}" class="product-photo">' +
                    '<div class="wmwproduct-grid__image-container">' +
                        '<div class="wmwproduct-grid__image">' +
                            '<div class="badge-container d-flex align-items-center">' + 
                                // <!-- MODIFIED: Critical Badges First -->
                                '<div class="{{hasSaleTag}}"><p>'+ varSale + '</p></div>' +
                                '<div class="{{hasClearanceTag}}"><p>Clearance</p></div>' +
                                '<div class="{{hasNoStock}}"><p>Out of Stock</p></div>' +
                                
                                // <!-- NEW: Added New Promo Badges -->
                                '<div class="{{hasFreeTanksTag}}"><p>Free Tank</p></div>' +
                                '<div class="{{hasFreeGunBagTag}}"><p>Free Gun Bag</p></div>' +
                                '<div class="{{hasFreeTowelTag}}"><p>Free Towel</p></div>' +

                                // <!-- Other Badges -->
                                '<div class="{{hasFreeShipping}}"><p>Free Shipping</p></div>' +
                                '<div class="{{hasOnlineTag}}"><p>Online Only</p></div>' +
                                '<div class="{{hasNewTag}}"><p>New</p></div>' +
                                '<div class="{{has150Tag}}"><p>3 for $150</p></div>' +
                                '<div class="{{has199Tag}}"><p>3 for $199</p></div>' +
                                '<div class="{{hasBogoTag}}"><p>BOGO FREE</p></div>' +
                            '</div>' +
                            '<div class="wmwproduct-grid__image__align">' +
                                '<img data-src="{{itemThumbUrl}}" src="{{itemThumbUrlSmall}}" alt="{{itemTitle}}" class="lazyload">' +
                            '</div>' +
                        '</div>' +

                    '</div>' +

                 

                    '<div class="wmwproduct-grid__sale {{daysClass}} ">' +
                        '<p class="sale-countdown">Sale ends in <span id="countbox_{{productId}}" class="timer-grid" data-gsecs="{{gsecs}}" data-gdays="{{gdays}}" ></span></p>' +
                        '<div><p>Save {{saveAmount}}</p></div>' +
                    '</div>' +
                '</a>' +

                '<div class="{{daysClass}} wmwproduct-grid__hover-others">' +
                    '{{itemSizes}}' +
                '</div></div>' +

                '{{ratings}}' +
                
                '<div class="wmwproduct-grid__title">' +
                    '<p>{{itemVendor}}</p>' +
                    '<h2>{{itemTitle}}</h2>' +
                '</div>' +
                

                '<div class="wmwproduct-grid__prices {{twoPrices}} product-price__{{discount_text_handle}}">' +
                    '<div>' +
                        '<p class="product-price {{discount_text_handle}}">{{discount_text}}</p>' + 
                        '<span class="wmwproduct-grid__prices__price {{class-price}}">{{sale_price}}</span>' +
                        '<span class="wmwproduct-grid__prices__price is-club-active">{{club_price}}</span>' +
                    '</div>' +
                    '<div class="compare-price">' +
                        '<p class="product-price price-text">Our Price</p>' +
                        '<span class="wmwproduct-grid__prices__price {{pricingActive}}">{{itemPrice}}</span>' +
                    '</div>' +
                    '<div class="mobile-only--variant wmwproduct-grid__hover-others">' +
                        '{{itemSizes}}' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>',

    // Pagination Template
    'previousActiveHtml': '<a class="wmwpagination__control wmwpagination__control--prev" href="{{itemUrl}}">Previous</a>',
    'previousDisabledHtml': '',
    'nextActiveHtml': '<a class="wmwpagination__control wmwpagination__control--next" href="{{itemUrl}}">Next</a>',
    'nextDisabledHtml': '',
    'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li class="active"><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemRemainHtml': '<li class="ellipsis disabled"><a href="#" onclick="return false;">{{itemTitle}}</a></li>',
    'paginateHtml': '{{previous}}<ul class="wmwpagination__parts">{{pageItems}}</ul>{{next}}',

    // Sorting Template
    'sortingHtml': '<ul name="SortBy" id="SortBy">{{sortingItems}}</ul>',
    'ctaBanner': '<div class="wmwgrid__item wmwgrid__one-quarter cta-banner--wrapper">'+
                    '<div class="wmwproduct-grid">'+
                        '<div class="thumb-box">'+
                            '<div class="product-photo">'+
                                '<div class="wmwproduct-grid__image-container"><div class="cta--video-link" data-cta-banner style="background:url({{ctaABannerImg}}) no-repeat center / cover;"><p class="cta-video--title"><span>Loading Video</span><img src="{{plyBtn}}"/></p></div></div>'+
                            '</div>'+
                        '</div>'+
                    '</div>'+
                '</div>'
};

/************************** BUILD PRODUCT LIST **************************/

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function (data, index) {
    /** Custom domestic vendor handling */
    var domesticVendors = [];
    var productsWrapper = $('#bc-sf-filter-products');
    if (productsWrapper.length && productsWrapper.data('domestic-vendors')) {
      domesticVendors = productsWrapper.data('domestic-vendors').split(",").map(function(item) {
        return item.trim().toLowerCase();
      });
    }

    if (domesticVendors.length && domesticVendors.indexOf(data.vendor.toLowerCase()) > -1) {
      data.domestic = true;
      data.wrapperClasses = ' show-au-only';
    } else {
      data.domestic = false;
      data.wrapperClasses = '';
    }

    /*** Prepare data ***/
    var images = data.images_info;
    data.price_min *= 100, data.price_max *= 100, data.compare_at_price_min *= 100, data.compare_at_price_max *= 100; // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    var noVariants = false;
    if (data.variants.length == 1) {
        var noVariants = true;
    }
    var soldOut = false;
    if (data.available == false) {
        var soldOut = true;
    }

    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function (e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    // Add wrapper Classes
      var wrapperClasses = data.wrapperClasses;
      itemHtml = itemHtml.replace(/{{wrapperClasses}}/g, wrapperClasses);

    // Add handle
    var itemHandle = data.handle;
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, itemHandle);

    // Add Thumbnail
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src']) : bcSfFilterConfig.general.no_image_url;
    var itemThumbUrlSmall = images.length > 0 ? this.optimizeImageSmall(images[0]['src']) : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);     
    itemHtml = itemHtml.replace(/{{itemThumbUrlSmall}}/g, itemThumbUrlSmall);     

    // itemHtml = itemHtml.replace(/{{testdata}}/g, )
    // Add Price
        var itemPriceHtml = '';
        var tagArray = data.tags;
        var discount_text = '';
        var discount_text_handle = '';
        var twoPrices = false;
        var isClearanceActive = false;
        var isSaleActive = false; 
        var isClubActive = false;
  		var isDepositActive = false;
        var pricingActive = '';
  		var isGiftCard = false;
        
  		if(jQuery.inArray("deposit", tagArray) !== -1) {
          isDepositActive = true;
        }
        if(data.product_type == 'gift-card' || data.product_type == 'gift-cards' || data.product_type == 'gift card' || data.product_type == 'gift cards' || data.product_type == 'Gift Cards' || data.product_type == 'Gift Card') {
          var isGiftCard = true;
        }

        if(jQuery.inArray("clearance", tagArray) !== -1 || jQuery.inArray("Clearance", tagArray) !== -1) {
            discount_text = 'Clearance';
            discount_text_handle = 'clearance-price';
            pricingActive = 'clearance-pricing-active';
            isClearanceActive = true;
            var sale_price = this.formatMoney(data.price_min);
            twoPrices = true;
        }
        else if (data.price_min < data.compare_at_price_max && isDepositActive == false && isGiftCard == false) {
            discount_text = 'Sale';
            discount_text_handle = 'sale-price';
            pricingActive = 'sale-pricing-active';
            isSaleActive = true;
            var sale_price = this.formatMoney(data.price_min);
            twoPrices = true;
        }
        else {
            for (tag = 0; tag < tagArray.length; tag++) {
              	if (isDepositActive) {
                    discount_text = 'Deposit';
                    discount_text_handle = 'deposit-price'
                    pricingActive = 'deposit-pricing-active';
                    var deposit_price = this.formatMoney(data.price_min);
                }
                else if (tagArray[tag].includes("clubpricing_")) {
                    discount_text = 'Club Price';
                    discount_text_handle = 'club-price'
                    pricingActive = 'club-pricing-active';
                    isClubActive = true;
                    twoPrices = true;
                    var cprice  = tagArray[tag].replace('clubpricing_','');
                    var club_price = this.formatMoney(cprice * 100);
                }
            }
        }
        itemHtml = itemHtml.replace(/{{pricingActive}}/g, pricingActive);
        itemHtml = itemHtml.replace(/{{discount_text_handle}}/g, discount_text_handle);
        itemHtml = itemHtml.replace(/{{discount_text}}/g, discount_text);
        
        if(twoPrices) {
            itemHtml = itemHtml.replace(/{{twoPrices}}/g, 'two-prices');
        }
        else {
            itemHtml = itemHtml.replace(/{{twoPrices}}/g, '');
        }


        if (isClearanceActive || isSaleActive) {
            if(isClearanceActive) {
                itemHtml = itemHtml.replace(/{{class-price}}/g, 'is-clearance-active');
            }
            else {
                itemHtml = itemHtml.replace(/{{class-price}}/g, 'is-sale-active');
            }
            if (data.title != '') {
                itemPriceHtml = this.formatMoney(data.compare_at_price_max);
            }
            if(data.price_min != data.price_max) {
              	itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
            }
            else {
                itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
            }
            itemHtml = itemHtml.replace(/{{sale_price}}/g, sale_price);
            itemHtml = itemHtml.replace(/{{club_price}}/g, '');
        }
        else if (isClubActive) {
            if (data.title != '') {
                itemPriceHtml = this.formatMoney(data.price_min);
            }
            if(data.price_min != data.price_max) {
              	itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
            }
            else {
                itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
            }
            itemHtml = itemHtml.replace(/{{club_price}}/g, club_price);
            itemHtml = itemHtml.replace(/{{sale_price}}/g, '');
        }
        else {
            if (data.title != '') {
                itemPriceHtml = this.formatMoney(data.price_min);
            }
            if(data.price_min != data.price_max) {
              	itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
            }
            else {
                itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
            }
            itemHtml = itemHtml.replace(/{{sale_price}}/g, '');
            itemHtml = itemHtml.replace(/{{club_price}}/g, '');
        }

    // Add Sizes
    var itemSizeHtml = [];
    var itemAvailableHtml = [];
    var newHTML = [];
    var itemSizeChecker;
    var addmeclass;
    
    if (data.title != '') {
        for (var i = 0; i < data['variants'].length; i++) {

            itemSizeHtml[i] =  data['variants'][i]['option_size'];
            itemAvailableHtml[i] =  data['variants'][i]['available'];

            if ( !itemAvailableHtml[i]) {
                newHTML[i] = '<a href="{{itemUrl}}" class="xs-inline-block size-option ' + itemSizeHtml[i] + '"><span class="size-item ' + itemAvailableHtml[i] + '">' + itemSizeHtml[i] + '</span></a>';
            } else {
                newHTML[i] = '<a href="{{itemUrl}}?variant=' + data['variants'][i]['id'] + '" class="xs-inline-block size-option ' + itemSizeHtml[i] + '"><span class="size-item ' + itemAvailableHtml[i] + '">' + itemSizeHtml[i] + '</span></a>';
            }
        }

        if (data['variants'].length > 1 && data['variants']['0']['option_size'] != 'undefined') {
            addmeclass = 'with-options'
        } else {
            addmeclass = '';
        }
        
        var combine = '<div class="size-options ' + addmeclass + ' ">' + newHTML.join('') + '</div>';

    }

    itemHtml = itemHtml.replace(/{{itemSizes}}/g, combine);


    // Show ratings
    var showRatings;
    if (data.title != '') {
        showRatings = '<span class="shopify-product-reviews-badge" data-id="{{productId}}"></span>';
    }
    
    itemHtml = itemHtml.replace(/{{ratings}}/g, showRatings);

    // Show Saving
    var itemShowSaving = '';
    var priceComparison = parseInt(data.compare_at_price_min);
    var priceMin = parseInt(data.price_min);
    if ((priceComparison <= priceMin + 100) || (data.compare_at_price_min === '0')) {
        itemShowSaving = 'wmwproduct-grid__prices--nosaving';
    }
    itemHtml = itemHtml.replace(/{{showSaving}}/g, itemShowSaving);

    // Percentage saving
    var itemPercentSaving = '';
    if (data.title != '') {
        itemPercentSaving = ((data.price_min / data.compare_at_price_min) * 100) - 100;
        itemPercentSaving = Math.abs(itemPercentSaving);
        itemPercentSaving = Math.trunc(itemPercentSaving);
    }
    itemHtml = itemHtml.replace(/{{percentSaving}}/g, itemPercentSaving);

    // Value saving
    var itemValueSaving = '';
    if (data.title != '') {
        itemValueSaving = this.formatMoney(data.compare_at_price_min);
    }
    itemHtml = itemHtml.replace(/{{valueSaving}}/g, itemValueSaving);

    // RRP
    var itemRRP = '';
    if (data.title != '') {
        itemRRP = this.formatMoney(data.compare_at_price_min);
    }
    itemHtml = itemHtml.replace(/{{rrp}}/g, itemRRP);

    // Add soldOut class
    var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

    // Add soldOut Label
    var itemSoldOutLabelHtml = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);

    // Add Vendor
    var itemVendorHtml = capitalize(data.vendor);
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    function toTitleCase(str) {
        return str.replace(/(?:^|\s)\w/g, function (match) {
            return match.toUpperCase();
        });
    }

    // Remove Vendor from title
    var itemTitle = data.title;
    var itemVendor = data.vendor += '';
    var regEx = new RegExp(itemVendor, "ig");
    var itemTitle = itemTitle.replace(regEx, '').replace(/^\s+/, '');

    // Add View or Add Hover
    var pathUrl = window.location.origin + window.location.pathname + '/products/' + data.handle;
    if (noVariants == true && soldOut == false) {
        var itemViewOrAdd = '<form action="/cart/add" method="post" enctype="multipart/form-data" id="AddToCartForm" class="AddToCartForm" itemprop="offers" itemscope itemtype="http://schema.org/Offer"><select name="id" class="product-form__variants no-js"><option selected="selected" value="' + firstVariant.id + '" data-sku="' + firstVariant.sku + '">' + firstVariant.name + '</option></select><button type="submit" name="add" class="wmwcollection__quickbutton add-to-cart"><span class="wmwicon"><svg width="30px" height="30px" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Cart"><g id="Group" transform="translate(2.000000, 3.000000)"><path d="M0,0.928571429 L4.86495857,0.155913073 C5.41042086,0.0693721376 5.9227607,0.441401403 6.00930164,0.986863694 C6.00934307,0.987124849 6.0093844,0.987386019 6.00942563,0.987647206 L9.23714041,21.441627 C9.31386392,21.9277018 9.73281856,22.2857143 10.2249113,22.2857143 L22.2857143,22.2857143" id="Path-4" stroke="#FFFFFF" stroke-linecap="round"></path><path d="M7.34759022,5.5 C7.32099164,5.5 7.29443547,5.50212245 7.26817454,5.50634714 C6.99553759,5.55020721 6.81007728,5.80677873 6.85393735,6.07941568 L8.71547395,17.6508443 C8.75446496,17.8932148 8.96363999,18.0714286 9.20912681,18.0714286 L23.3082559,18.0714286 C23.5499045,18.0714286 23.7569731,17.8986089 23.8001935,17.6608569 L25.9037391,6.0894283 C25.9091032,6.05992099 25.9118016,6.0299909 25.9118016,6 C25.9118016,5.72385763 25.6879439,5.5 25.4118016,5.5 L7.34759022,5.5 Z" id="Rectangle-2" stroke="#FFFFFF"></path><path d="" id="Path-3" stroke="#979797"></path><circle id="Oval-2" stroke="#FFFFFF" cx="20.4285714" cy="24.1428571" r="1.85714286"></circle><circle id="Oval-2-Copy" stroke="#FFFFFF" cx="11.1428571" cy="24.1428571" r="1.85714286"></circle></g></g></g></svg></span><span class="wmwicon__fallback-text">Add to Cart</span></button></form>';
    } else {
        var itemViewOrAdd = '<a href="' + pathUrl + '" class="wmwcollection__quickbutton" title="View Product"><span class="wmwicon"><svg width="30px" height="30px" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Icon/Open" stroke="#FFFFFF"><circle id="Oval-Copy" cx="11" cy="19" r="8.5"></circle><g id="Group-2" transform="translate(18.625631, 11.374369) rotate(-225.000000) translate(-18.625631, -11.374369) translate(6.625631, 5.874369)" stroke-linecap="round"><path d="M23.1715729,5.66470768 L1,5.5" id="Path-11"></path><polyline id="Path-2" stroke-linejoin="round" transform="translate(2.500000, 5.500000) rotate(-270.000000) translate(-2.500000, -5.500000) " points="-2.5 3 2.50995295 8 7.5 3.01986635"></polyline></g></g></g></svg></span><span class="wmwicon__fallback-text">View Product</span></a>';
    }
    itemHtml = itemHtml.replace(/{{itemViewOrAdd}}/g, itemViewOrAdd);

    // Wishlist details
    var firstVariantId = firstVariant.id;
    var productId = data.id;
    var productName = data.title;
    itemHtml = itemHtml.replace(/{{firstVariantId}}/g, firstVariantId);
    itemHtml = itemHtml.replace(/{{productId}}/g, productId);
    itemHtml = itemHtml.replace(/{{productName}}/g, productName);

    //
    // SALE
    //
    var tagArray = data.tags;
    var tag;
    var sale = false;
    var hideProduct = false;
    var hasNoStock = false;
    var hasSaleTag = false;
    var hasClearanceTag = false;
    var hasOnlineTag = false;
    var hasNoStock = false;
    var hasNewTag = false;
    var has150Tag = false;
    var has199Tag = false;
    var hasBogoTag = false;
    var hasFreeShipping = false;
    var saleTime = '';
    
    // <!-- NEW: Added New Promo Badge Flags -->
    var hasFreeTanksTag = false;
    var hasFreeGunBagTag = false;
    var hasFreeTowelTag = false;
    
    if(!data.available) { 
        hasNoStock = true; 
    }

     // If Product Price Max is greater than $300 Add Free Shipping
     // This logic is moved into the new badge block
    
    // Check tags for sale
    for (tag = 0; tag < tagArray.length; tag++) {
        if(tagArray[tag] == 'Hide' || tagArray[tag] == 'hide') { 
            hideProduct = true;
        }
        if(tagArray[tag] == 'Sale' || tagArray[tag] == 'sale') { 
            hasSaleTag = true; // Note: isSaleActive is the flag used for price logic
        }
        if(tagArray[tag] == 'Clearance' || tagArray[tag] == 'clearance') { 
            hasClearanceTag = true; 
        }
        if(tagArray[tag] == 'Online Only' || tagArray[tag] == 'online-only') {
            hasOnlineTag = true;
        }
        if(tagArray[tag] == 'New' || tagArray[tag] == 'new') {
            hasNewTag = true;
        }
        if(tagArray[tag] == 'Multi-150' || tagArray[tag] == 'multi-150') {
            has150Tag = true;
        }
        if(tagArray[tag] == 'Multi-199' || tagArray[tag] == 'multi-199') {
            has199Tag = true;
        }
        if(tagArray[tag] == 'bogo-label' || tagArray[tag] == 'Bogo-label') {
            hasBogoTag = true;
        }
        
        // <!-- NEW: Check for Free Tanks Tag -->
        if(tagArray[tag] == 'bfcm-2025-tank-holding') {
            hasFreeTanksTag = true;
        }

        if (tagArray[tag].indexOf('special_from_date=') >= 0) {
            var dateStart = tagArray[tag].replace('special_from_date=', '');
        } else if (tagArray[tag].indexOf('special_to_date=') >= 0) {
            var dateEnd = tagArray[tag].replace('special_to_date=', '');
            var dateEnd = dateEnd.replace(' 0:00', '');
        }
    }

    // <!-- NEW: Check for Gun Bag and Towel Badges -->
    // User confirmed these are mutually exclusive
    if (!hasFreeTanksTag) {
        if (data.product_type.toLowerCase().includes('spearguns') && data.price_min > 29900000) { // 299 * 100
            hasFreeGunBagTag = true;
        } else if (data.product_type.toLowerCase().includes('wetsuits') && data.price_min > 2500000000) { // 250 * 100
            hasFreeTowelTag = true;
        }
    }

    let saving_amount = (data.compare_at_price_max - data.price_min); 
    var saving_money = '$' + ((data.compare_at_price_max - data.price_min) / 100.00);
    saving_money = saving_money.split('.'); 
    saving_money = saving_money[0]; 

    if(hideProduct) {
        itemHtml = itemHtml.replace(/{{hidden}}/g, 'hidden');
    }
    else {
        itemHtml = itemHtml.replace(/{{hidden}}/g, '');
    }


    // <!-- MODIFIED: Replaced mutually exclusive badge logic with concurrent logic -->

    // --- Critical Badges ---
    if(hasNoStock) { 
        itemHtml = itemHtml.replace(/{{hasNoStock}}/g, 'collection-badge oos-badge'); 
    } else {
        itemHtml = itemHtml.replace(/{{hasNoStock}}/g, 'd-none');
    }

    if(hasClearanceTag) {
        itemHtml = itemHtml.replace(/{{hasClearanceTag}}/g, 'collection-badge clearance-badge');
    } else {
        itemHtml = itemHtml.replace(/{{hasClearanceTag}}/g, 'd-none');
    }
    
    if(isSaleActive && !hasClearanceTag) { // Don't show "Sale" if it's "Clearance"
        itemHtml = itemHtml.replace(/{{hasSaleTag}}/g, 'collection-badge sale-badge'); 
        
        if(saving_amount > 5000) { 
            var saving_money_sale = '$' + ((data.compare_at_price_max - data.price_min) / 100.00);
            saving_money_sale = saving_money_sale.split('.'); 
            saving_money_sale = saving_money_sale[0]; 
            itemHtml = itemHtml.replace(/{{saveAmount}}/g, saving_money_sale); 
        } 
        else { 
            var saving_percent = Math.trunc(100 - (data.price_min * 100 / data.compare_at_price_max)); 
             
            if(saving_percent >= 5) { 
                itemHtml = itemHtml.replace(/{{saveAmount}}/g, saving_percent + '%'); 
            } 
            else { 
                itemHtml = itemHtml.replace(/{{saveAmount}}/g, saving_money);
            } 
        }
    } else {
        itemHtml = itemHtml.replace(/{{hasSaleTag}}/g, 'd-none');
        itemHtml = itemHtml.replace(/{{saveAmount}}/g, saving_money); // Default save amount if not on sale
    }

    // --- New Promo Badges ---
    if(hasFreeTanksTag) {
        itemHtml = itemHtml.replace(/{{hasFreeTanksTag}}/g, 'collection-badge free-tanks-badge'); // Added a new class
    } else {
        itemHtml = itemHtml.replace(/{{hasFreeTanksTag}}/g, 'd-none');
    }

    if(hasFreeGunBagTag) {
        itemHtml = itemHtml.replace(/{{hasFreeGunBagTag}}/g, 'collection-badge free-gun-bag-badge'); // Added a new class
    } else {
        itemHtml = itemHtml.replace(/{{hasFreeGunBagTag}}/g, 'd-none');
    }

    if(hasFreeTowelTag) {
        itemHtml = itemHtml.replace(/{{hasFreeTowelTag}}/g, 'collection-badge free-towel-badge'); // Added a new class
    } else {
        itemHtml = itemHtml.replace(/{{hasFreeTowelTag}}/g, 'd-none');
    }

    // --- Other Badges ---
    if(data.price_max > 30000) { // Free Shipping
        itemHtml = itemHtml.replace(/{{hasFreeShipping}}/g, 'collection-badge free-shipping-badge'); 
    }
    else {
        itemHtml = itemHtml.replace(/{{hasFreeShipping}}/g, 'd-none');
    }

    if(hasOnlineTag) {
        itemHtml = itemHtml.replace(/{{hasOnlineTag}}/g, 'collection-badge has-online');
    } else {
        itemHtml = itemHtml.replace(/{{hasOnlineTag}}/g, 'd-none');
    }

    if(hasNewTag) { 
        itemHtml = itemHtml.replace(/{{hasNewTag}}/g, 'collection-badge has-new');
    } else {
        itemHtml = itemHtml.replace(/{{hasNewTag}}/g, 'd-none');
    } 

    if(has150Tag) {
        itemHtml = itemHtml.replace(/{{has150Tag}}/g, 'collection-badge clearance-badge'); // Uses clearance-badge
    } else {
        itemHtml = itemHtml.replace(/{{has150Tag}}/g, 'd-none');
    }
    
    if(has199Tag) {
        itemHtml = itemHtml.replace(/{{has199Tag}}/g, 'collection-badge clearance-badge'); // Uses clearance-badge
    } else {
        itemHtml = itemHtml.replace(/{{has199Tag}}/g, 'd-none');
    }
    
    if(hasBogoTag) {
        itemHtml = itemHtml.replace(/{{hasBogoTag}}/g, 'collection-badge clearance-badge'); // Uses clearance-badge
    } else {
        itemHtml = itemHtml.replace(/{{hasBogoTag}}/g, 'd-none');
    }
    // <!-- END MODIFICATION -->


    // Calculate time remaining and if sale has started
    if ((dateStart != undefined) && (dateEnd != undefined) && (!hasNoStock)) {
        var dthen = new Date(dateEnd);
        var dstart = new Date(dateStart);
        var cdate = new Date();

        var Difference_In_Time = dthen.setHours(23, 59, 59, 999) - cdate.getTime(); 
  
        // To calculate the no. of days between two dates 
        var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24); 

        var gdays = Difference_In_Days;
        var daysClass; 

       
        if (gdays > 15) {
            daysClass = 'more-than-10days';
        }
        else if(gdays > 0 && gdays <= 15) {
            daysClass = 'less-than-10days';
        }
        else {
            daysClass = 'expires'
        }
        
        var dnow = new Date();
        var ddiff = dthen.setHours(23, 59, 59, 999) - dnow.getTime();

        var timeToStart = dnow.getTime() - dstart.setHours(0, 00, 00, 001);
        var started = (timeToStart > 0) ? true : false;
        var gsecs = Math.floor(ddiff.valueOf() / 1000);

        if ((ddiff > 0) && started) {
            var sale = true;
        }
    }
    itemHtml = itemHtml.replace(/{{daysClass}}/g, daysClass);
    itemHtml = itemHtml.replace(/{{gdays}}/g, gdays);
    itemHtml = itemHtml.replace(/{{gsecs}}/g, gsecs);

    // Sale class
    var saleClass = '';
    if (sale == true) {
        saleClass = 'wmwproduct-grid--sale';
    }
    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

    // Add main attribute (Always put at the end of this function
    itemHtml = itemHtml.replace(/{{page}}/g, parseInt(this.queryParams.page));
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, itemTitle);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    if(index == 7 && cta_banner.has_cta_banner && document.querySelectorAll('.cta-banner--wrapper').length < 1) {
        var itemHTMLCTA = bcSfFilterTemplate.ctaBanner
        var ctaBannerImg = cta_banner.cta_banner_collection
        itemHTMLCTA = itemHTMLCTA.replace(/{{ctaABannerImg}}/g, ctaBannerImg)
        itemHTMLCTA = itemHTMLCTA.replace(/{{plyBtn}}/g, cta_banner.ply_btn)

        return itemHTMLCTA
    }
    return itemHtml;
};

// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function (data) {
    // // Add Description
    // var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
    // // Truncate by word
    // itemDescription = (itemDescription.split(" ")).length > 51 ? itemDescription.split(" ").splice(0, 51).join(" ") + '...' : itemDescription.split(" ").splice(0, 51).join(" ");
    // // Truncate by character
    // itemDescription = itemDescription.length > 350 ? itemDescription.substring(0, 350) + '...' : itemDescription.substring(0, 350);
    // itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
};

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData = function (data) {
    for (var k in data) {
        // Featured image
        if (data['images_info'] > 0) {
            data[k]['featured_image'] = data['images_info'][0];
        } else {
            data[k]['featured_image'] = { width: '', height: '', aspect_ratio: 0 }
        }

        // Add Options
        var optionsArr = [];
        for (var i in data[k]['options_with_values']) {
            optionsArr.push(data[k]['options_with_values'][i]['name']);
        }
        data[k]['options'] = optionsArr;

        // Customize variants
        for (var i in data[k]['variants']) {
            var variantOptionArr = [];
            var count = 1;
            var variant = data[k]['variants'][i];
            // Add Options
            var variantOptions = variant['merged_options'];
            if (Array.isArray(variantOptions)) {
                for (var j = 0; j < variantOptions.length; j++) {
                    var temp = variantOptions[j].split(':');
                    data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];
                    data[k]['variants'][i]['option_' + temp[0]] = temp[1];
                    variantOptionArr.push(temp[1]);
                }
                data[k]['variants'][i]['options'] = variantOptionArr;
            }
            data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;
            data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100;
        }

        // Add Description
        data[k]['description'] = data[k]['body_html'];
    }
    return data;
};

/************************** END BUILD PRODUCT LIST **************************/

// Build Pagination
BCSfFilter.prototype.buildPagination = function (totalProduct) {
    if (this.getSettingValue('general.paginationType') == 'default') {
        // Get page info
        var currentPage = parseInt(this.queryParams.page);
        var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

        // If it has only one page, clear Pagination
        if (totalPage == 1) {
            jQ(this.selector.bottomPagination).html('');
            return false;
        }

        if (this.getSettingValue('general.paginationType') == 'default') {
            var paginationHtml = bcSfFilterTemplate.paginateHtml;

            // Build Previous
            var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
            previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
            paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

            // Build Next
            var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
            nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
            paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

            // Create page items array
            var beforeCurrentPageArr = [];
            for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
                beforeCurrentPageArr.unshift(iBefore);
            }
            if (currentPage - 4 > 0) {
                beforeCurrentPageArr.unshift('...');
            }
            if (currentPage - 4 >= 0) {
                beforeCurrentPageArr.unshift(1);
            }
            beforeCurrentPageArr.push(currentPage);

            var afterCurrentPageArr = [];
            for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
                afterCurrentPageArr.push(iAfter);
            }
            if (currentPage + 3 < totalPage) {
                afterCurrentPageArr.push('...');
            }
            if (currentPage + 3 <= totalPage) {
                afterCurrentPageArr.push(totalPage);
            }

            // Build page items
            var pageItemsHtml = '';
            var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
            for (var iPage = 0; iPage < pageArr.length; iPage++) {
                if (pageArr[iPage] == '...') {
                    pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
                } else {
                    pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
                }
                pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
                pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
            }
            paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

            jQ(this.selector.bottomPagination).html(paginationHtml);
        }
    }
};

/************************** BUILD TOOLBAR **************************/

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function () {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        // var sortingArr = this.getSortingList();
        var sortingArr = {'best-selling':"Sort: Best Selling",'created-ascending':"Sort: Date, old to new",'created-descending':"Sort: Date, new to old",'manual':"Sort: Featured",'price-ascending':"Sort: Price, low to high",'price-descending':"Sort: Price, high to low",'title-ascending':"Sort: Alphabetically, A-Z",'title-descending':"Sort: Alphabetically, Z-A"};
        if (sortingArr) {
            
            var paramSort = this.queryParams.sort || '';

            // Build content
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                activeClass = '';
                if (paramSort == k) {
                    activeClass = 'active';
                    labelName = sortingArr[k];
                }
                sortingItemsHtml += '<li><a href="#" data-sort="' + k + '"  class="' + activeClass + '">' + sortingArr[k] + '</a></li>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // jQ('#sortByButton').text(labelName.replace('Sort: ',''));
            

            // Set current value
            // jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

BCSfFilter.prototype.buildSortingEvent = function () {
    var _this = this;
    jQ('#SortBy a').click(function (e) {
      e.preventDefault();
      onInteractWithToolbar(e, 'sort', _this.queryParams.sort, jQ(this).data('sort'));
      $('.ram-dp').removeClass('active');

        // Hide filter in mobile when filter click
        mobileOnly();
    });
  };


/************************** END BUILD TOOLBAR **************************/

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function (data, eventType) {
    saleTimer(data);
    
    var screenWidth = $(window).width();

    if(screenWidth <= 768) {
        mobileEqual(data);
    }
    else if (screenWidth >= 769 && screenWidth <= 1280) {
        laptopEqual(data);
    }
    else {
        desktopEqual(data);
        // ('desktopEqual calling');
    }

    $(window).on('resize', function() {
        var screenWidth = $(window).width();
        if(screenWidth <= 768) {
            mobileEqual(data);
            $('.wmwgrid__item').removeClass('show-review-desktop');
            $('.wmwgrid__item').removeClass('show-review-laptop');
            $('.wmwgrid__item').removeAttr('data-desktop_loop');
            $('.wmwgrid__item').removeAttr('data-laptop_loop');
        }
        else if (screenWidth >= 769 && screenWidth <= 1280) {
            laptopEqual(data);
            $('.wmwgrid__item').removeClass('show-review-desktop');
            $('.wmwgrid__item').removeClass('show-review-mobile');
            $('.wmwgrid__item').removeAttr('data-desktop_loop');
            $('.wmwgrid__item').removeAttr('data-mobile_loop');
        }
        else {
            desktopEqual(data);
            $('.wmwgrid__item').removeClass('show-review-mobile');
            $('.wmwgrid__item').removeClass('show-review-laptop');
            $('.wmwgrid__item').removeAttr('data-mobile_loop');
            $('.wmwgrid__item').removeAttr('data-laptop_loop');
        }
    })
    

    // if (window.setupInstabadge){
    //     window.setupInstabadge();
    // }
    //$('[data-mh]').matchHeight();

    // if (window.SPR) {
    //     SPR.initDomEls();
    //     SPR.loadBadges();
    // }
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function (data, eventType) {
    if (eventType != 'sort') {
        if (eventType != 'page') {
            filterDropdowns();
        }
    }
    if (eventType != 'init') {
        //window.setupInstabadge();

        // window.scrollTo(0, 0);
        // Slide to top when filter is click
        // scrollToAfterFilter();

        // Hide filter in mobile when filter click
        mobileOnly();
    }

    jQuery(".thumb-box").find("a").on("touchstart", function () { isScrolling = !1 }).on("touchmove", function () { isScrolling = !0 }).on("touchend", function () { isScrolling || (window.location = jQ(this).attr("href")) });
};

BCSfFilter.prototype.buildInfiniteLoadingEvent = function(data) {
  var self = this;
  // Get total products
  var totalProduct = parseInt(data.total_product);
  /* Get limit per page */
  var limitPerPage = parseInt(self.getSettingValue('general.limit'));
  var currentPage = parseInt(self.queryParams.page);

        var getReviewsInterval = setInterval(function() {
            getReviews();
        }, 1000);

        $(window).on('resize', function() {
            var getReviewsInterval = setInterval(function() {
                getReviews();
            }, 1000);
        })

        function getReviews() {
            $('.wmwcollection__product-grid .wmwgrid__item.wmwgrid__one-quarter').each(function() {
                var rating = $('.spr-badge', this).data('rating');
                if(typeof rating !== 'undefined' && rating != "0.0") {
                    var screenWidth = $(window).width();
                    if(screenWidth <= 768) {
                        var mobile_loop_num = $(this).data('mobile_loop');
                        $('.wmwcollection__product-grid .wmwgrid__item.wmwgrid__one-quarter[data-mobile_loop="' + mobile_loop_num + '"]').addClass('show-review-mobile');
                    }
                    else if (screenWidth >= 769 && screenWidth <= 1280) {
                        var laptop_loop_num = $(this).data('laptop_loop');
                        $('.wmwcollection__product-grid .wmwgrid__item.wmwgrid__one-quarter[data-mobile_loop="' + laptop_loop_num + '"]').addClass('show-review-laptop');
                    }
                    else {
                        var desktop_loop_num = $(this).data('desktop_loop');
                        $('.wmwcollection__product-grid .wmwgrid__item.wmwgrid__one-quarter[data-desktop_loop="' + desktop_loop_num + '"]').addClass('show-review-desktop');
                    }

                    clearInterval(getReviewsInterval);
                }
            });
        }
    

  /* Check if total products is greater than limit per page * curent page, do the infinite loading function, else do nothing */
  if (totalProduct > (limitPerPage * currentPage)) {

    // Using scrolling to prevent callling onscroll twice
    var scrolling = 0;

    // onscroll event
    // When windown reaches the bottom of product list
    var scrollToBottom = false;

    // Pagination selector
    var paginationSelector = jQ(self.getSelector('bottomPagination'));

    // Check if pagination exists, do the infinite function
    if (paginationSelector.length > 0) {
      // When scroll down, do the infinite function
      jQ(window).scroll(function(e) {
        e.preventDefault();
        e.stopPropagation();

        // get height of scroll bar
        var scrollbarHeight = jQ(window).height() * (jQ(window).height() / jQ(document).outerHeight());

        // get position of the pagination bottom
        var maxPos = parseInt(paginationSelector.offset().top) - 1000;
        var maxScroll = parseInt(jQ(window).scrollTop()) + scrollbarHeight + self.getSettingValue('general.positionShowInfiniteLoading');
        if ((jQ(window).scrollTop() + jQ(window).height() + scrollbarHeight) >= jQ(document).outerHeight() - 100) {
          scrollToBottom = true;
        }

        // Begin loading more products
        if (scrolling == 0 && data.products.length > 0) {
          if (maxScroll >= maxPos || (maxScroll < maxPos && scrollToBottom)) {
            // Show Loading
            self.showLoadMoreLoading();

            // Prevent scrolling twice
            scrolling = 1;

            // Next page
            currentPage++;
            

            

            // Send request if current page is smaller or equal to total number of pages
            var totalPage = Math.ceil(data.total_product / self.getSettingValue('general.limit'));

            if (currentPage <= totalPage) {
              self.internalClick = true;
              self.queryParams.limit = self.getSettingValue('general.limit');
              self.queryParams.page = currentPage;
              // Append "page" param to url
              // Used to Scroll to the previous position after returning from Product page

              if (self.getSettingValue('general.paginationTypeAdvanced')) {
                var newUrl = self.buildToolbarLink('page', currentPage - 1, currentPage);
                self.onChangeData(newUrl, 'page');
              } else {
                self.getFilterData('page');
              }
            }
          }
        }
      });
    }
  }
  this.scrollBackPositionHistoryBack()
};

function desktopEqual(data) {
    var counter = 1;
    var counterDiv = 1;
    
    $('.wmwcollection__product-grid .wmwgrid__item.wmwgrid__one-quarter').each(function() {
        $(this).attr('data-desktop_loop', counterDiv);
        if(counter == 4) {
            counterDiv++
            counter = 0;
        }
        counter++;
    });
    
    var loop_count = $(".wmwcollection__product-grid .wmwgrid__item.wmwgrid__one-quarter").map(function() {
        return $(this).data('desktop_loop');
    }).get();
    
    var highest = Math.max.apply(Math, loop_count);
    
    for(var loop = 1; loop < highest; loop++) {
        var maxHeight = -1;
        var target_title = $('.wmwgrid__item[data-desktop_loop="'+ loop +'"] .wmwproduct-grid__title');
    
        target_title.each(function() {
            maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
        });
        target_title.each(function() {
            $(this).height(maxHeight);
        });
    }
}

function laptopEqual(data) {
    var counter = 1;
    var counterDiv = 1;

    $('.wmwcollection__product-grid .wmwgrid__item.wmwgrid__one-quarter').each(function() {
        $(this).attr('data-laptop_loop', counterDiv);
        if(counter == 3) {
            counterDiv++
            counter = 0;
        }
        counter++;
    });

    var loop_count = $(".wmwcollection__product-grid .wmwgrid__item.wmwgrid__one-quarter").map(function() {
        return $(this).data('laptop_loop');
    }).get();

    var highest = Math.max.apply(Math, loop_count);

    for(var loop = 1; loop < highest; loop++) {
        var maxHeight = -1;
        var target_title = $('.wmwgrid__item[data-laptop_loop="'+ loop +'"] .wmwproduct-grid__title');

        target_title.each(function() {
            maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
        });
        target_title.each(function() {
            $(this).height(maxHeight);
        });
    }
}

function mobileEqual(data) {
    var counter = 1;
    var counterDiv = 1;

    $('.wmwcollection__product-grid .wmwgrid__item.wmwgrid__one-quarter').each(function() {
        $(this).attr('data-mobile_loop', counterDiv);
        if(counter == 2) {
            counterDiv++
            counter = 0;
        }
        counter++;
    });

    var loop_count = $(".wmwcollection__product-grid .wmwgrid__item.wmwgrid__one-quarter").map(function() {
        return $(this).data('mobile_loop');
    }).get();
    
    var highest = Math.max.apply(Math, loop_count);
    for(var loop = 1; loop < (highest + 1); loop++) {
        var maxHeight = -1;
        var target_title = $('.wmwgrid__item[data-mobile_loop="'+loop+'"] .wmwproduct-grid__title');
        target_title.each(function() {
            maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
        });

        target_title.each(function() {
            $(this).height(maxHeight);
        });
    }
}



// Sale timer
function saleTimer(data) {
    $('.wmwproduct-grid--sale').each(function () {
        var $timer = $(this).find('.timer-grid');
        var seconds = $timer.data('gsecs');
        var days = $timer.data('gdays');
        var timerProductId = $timer.attr('id');

        CountBack(seconds, timerProductId);
    });
}

// Change how filter dropdowns behave
function filterDropdowns() {
    var selectors = [
        $filter_button = $('.bc-sf-filter-option-block'),
        $filter_dropdown = $('.bc-sf-filter-option-block').children('.bc-sf-filter-block-content'),
        $treeParent = $('.bc-sf-filter-option-single-list > li > a, .parent-filter'),
        $treeFirstChild = $('.bc-sf-filter-option-single-list > li:first-of-type > a'),
    ];

    // for the tree
    $treeParent.on('click', function (e) {
        e.preventDefault();

        $(this).siblings('ul').toggle();
        $(this).toggleClass('active');
    });

    $treeFirstChild.siblings('ul').show();
    $treeFirstChild.addClass('active');

    $('ul.bc-sf-filter-option-single-list li a').each(function (index,val) { $(this).attr('href', $(this).attr("href").replace(' ', "-")) });
}

// product thumbnail hover

// mobile only
function mobileOnly() {
    if ($(window).width() <= 1099) {
        $('#bc-sf-filter-tree').hide();
    } else {
        $('#bc-sf-filter-tree').show();
    }
}

function scrollToAfterFilter() {
    if ($(window).width() <= 1099) {
            
        $('html, body').animate({
            scrollTop: $(".wmwcollection__refine").offset().top - 100
        }, 500);

    } else {
        $('html, body').animate({
            scrollTop: $("#bc-sf-filter-products").offset().top - 250
        }, 500);
    }
}

BCSfFilter.prototype.prepareFilterParams = function(params, eventType) {
    // Get collection id
    params.collection_scope = parseInt(this.collectionId);
    if (eventType == 'history') {
        if (History.getState().data.hasOwnProperty('param') && History.getState().data.param.hasOwnProperty('collection_scope')) {
            params.collection_scope = this.collectionId = parseInt(History.getState().data.param.collection_scope);
        } else {
            params.collection_scope = this.collectionId = parseInt(bcSfFilterConfig.general.collection_id);
        }
    }
    // Get product/variant avaialable or not
    if (this.getSettingValue('general.availableAfterFiltering') == true) {
        params.product_available = this.checkExistFilterOptionParam() === true ? true : this.productAvailable;
        params.variant_available = this.checkExistFilterOptionParam() === true ? true : this.variantAvailable;
    } else {
        params.product_available = this.productAvailable;
        params.variant_available = this.variantAvailable;
    }
    // Get Tag value
    if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) params.tag = this.collectionTags;
    // Display filter option items even they return no product
    if (this.getSettingValue('general.showOutOfStockOption')) params.zero_options = true;
    // Build Filter tree or not
    params.build_filter_tree = (typeof eventType !== 'undefined' && this.imutableFilterTree.indexOf(eventType) > -1) ? false : true; // Except events of elements in filter tree, all remaining events do not rebuild filter tree
    // Enable cache when request params doest not have filter option values, "page" param equal to 1 and "sort" param equal to default sorting
    //params.check_cache = (this.checkExistFilterOptionParam() === false && params['page'] == 1 && params['sort'] == this.defaultSorting && params['limit'] == this.getSettingValue('general.limit') && !this.isSearchPage() && !this.isVendorPage()) ? true : false;
    params.check_cache = false;
    // Turn on price mode
    if (this.getSettingValue('general.priceMode') != '') params['price_mode'] = this.getSettingValue('general.priceMode');
  	// Tag mode
    if (this.getSettingValue('general.tagMode') != '') params['tag_mode'] = this.getSettingValue('general.tagMode');
    // Availability Sorting
    if (this.getSettingValue('general.sortingAvailableFirst')) params.sort_first = 'available';
    // Vendor page: Get Vendor param
    if (this.isVendorPage() && params.hasOwnProperty('q')) {
        var vendorParam = this.getSettingValue('general.vendorParam');
        // params[vendorParam] = [params['q'].replace(/\+/g, ' ')];
        params[vendorParam] = [params['q'].replace(/\+/g, ' '), params['q'].replace(/\+/g, ' ').toLowerCase()];
        delete params['q'];
    }
    return params;
};

function ipLookUp (callback) {
    $.get("https://ipinfo.io", function(response) {
//         callback(response);
    }, "json");
}
/* boost-start-2.4.2 */
/* If you upgrade the lib to the version >= 2.4.2, please comment the functions below out */
BCSfFilter.prototype.buildRobotsMetaTag = function(data) { var self = this; var metaContent = 'meta[content="noindex,nofollow"]'; if (self.checkIfPFParamsPartOfAURL() === true && jQ('head').find( metaContent).length === 0) { var m = document.createElement('meta'); m.name = 'robots'; m.content = 'noindex,nofollow'; document.head.appendChild(m); } }; BCSfFilter.prototype.checkIfPFParamsPartOfAURL = function() { var self = this; if (window.location.search.length > 0 && window.location.search.indexOf('pf_') > 0) { return true; } return false; };
/* boost-end-2.4.2 */

/* Boost-Start-42588 */
BCSfFilter.prototype.buildFilterOption = function(content, data, filterTreeId) {
    var blockTitle = data.label;
    var blockId = this.class.filterOption + '-' + this.slugify(blockTitle);

    // Build wrapper of a filter option
    var html = this.getTemplate('filterOptionWrapper');
    html = html.replace(/{{blockTitle}}/g, blockTitle);
    html = html.replace(/{{blockTitleSlugify}}/g, this.slugify(blockTitle));
    html = html.replace(/{{blockTypeClass}}/g, this.class.filterOption + '-' + data.displayType);
    html = html.replace(/{{blockId}}/g, blockId);
    html = html.replace(/{{blockContent}}/g, content);

    // Tooltip
    html = html.replace(/{{tooltip}}/g, this.buildFilterOptionTooltip(data));

    // Add Clear button to a filter option block when URL has param like type of the filter option
    // Except type of filter option is collection
    var clearButtonHtml = '';
    if (this.queryParams.hasOwnProperty(data.filterOptionId) && this.queryParams[data.filterOptionId]) {
        clearButtonHtml = '<a href="javascript:;" role="button" aria-label="' + this.getSettingValue('label.clear') + '" class="' + this.class.clearButton + '" onClick="clearFilterOption(event, this, \'' + data.filterOptionId + '\')">' + this.getSettingValue('label.clear') + '</a>';
    }
    html = html.replace(/{{clearButton}}/g, clearButtonHtml);

    // Get Show more type
    var showMoreType = null;
    if (['list', 'box', 'swatch'].indexOf(data.displayType) > -1) showMoreType = 'scrollbar';
    if (data.hasOwnProperty('showMoreType') && data.showMoreType) showMoreType = data.showMoreType;
    if (this.getSettingValue('general.showMoreType') != '' && ['list'].indexOf(data.displayType) > -1) showMoreType = this.getSettingValue('general.showMoreType');

    // Add Search Box
    var filterBlockShowSearchBoxHtml = '';
    var showSearchBoxFilterPC = data.hasOwnProperty('showSearchBoxFilterPC') ? data.showSearchBoxFilterPC : false;
    var showSearchBoxFilterMobile = data.hasOwnProperty('showSearchBoxFilterMobile') ? data.showSearchBoxFilterMobile : false;
    if (this.getSettingValue('general.showSearchBoxFilterPCByDefault')) showSearchBoxFilterPC = true;
    if (this.getSettingValue('general.showSearchBoxFilterMobileByDefault')) showSearchBoxFilterMobile = true;
    var includeShowMoreTypeSearchBoxArray = ['none', 'scrollbar'];
    var excludeFilterTypeSearchBoxArray = ['price', 'percent_sale', 'stock'];
    var excludeDisplayTypeSearchBoxArray = ['range'];
    if (includeShowMoreTypeSearchBoxArray.indexOf(showMoreType) != -1 && excludeFilterTypeSearchBoxArray.indexOf(data.filterType) == -1 && excludeDisplayTypeSearchBoxArray.indexOf(data.displayType) == -1 && data.values.length > 1) {
        if ((!this.isMobile() && showSearchBoxFilterPC) || (this.isMobile() && showSearchBoxFilterMobile)) {
            filterBlockShowSearchBoxHtml = this.getTemplate('filterOptionShowSearchBox');
            filterBlockShowSearchBoxHtml = filterBlockShowSearchBoxHtml.replace(/{{filterOptionShowSearchBoxClass}}/g, this.class.filterOptionShowSearchBox);
            filterBlockShowSearchBoxHtml = filterBlockShowSearchBoxHtml.replace(/{{dataShowSearchBoxParentID}}/g, data.filterOptionId);
            filterBlockShowSearchBoxHtml = filterBlockShowSearchBoxHtml.replace(/{{filterSearchOptionsLabel}}/g, this.getSettingValue('label.searchOptions'));
        }
    }
    html = html.replace(/{{filterBlockShowSearchBox}}/g, filterBlockShowSearchBoxHtml);

    // Add common class
    html = this.buildFilterTreeClass(html);

    // Build Html
    if (html !== '') {
        var htmlElement = jQ(html);

        // Add additional attribute
        htmlElement.attr({
            'data-id': data.filterOptionId,
            'data-type': data.filterType,
            'data-display-type': data.displayType,
            'data-select-type': data.selectType,
            'data-title': blockTitle,
            'data-prefix': data.prefix,
            'data-block-id': blockId + filterTreeId,
        });

        // Collapse each Filter options
        // If collapseOnPCByDefault is turned on true, all filter options will be collapsed on PC, even though they are set on the filter option setting.
        // If collapseOnMobileByDefault is turned on true, all filter options will be collapsed on Mobile, even though they are set on the filter option setting.
        var isCollapsePC = data.hasOwnProperty('isCollapsePC') ? data.isCollapsePC : false;
        var isCollapseMobile = data.hasOwnProperty('isCollapseMobile') ? data.isCollapseMobile : false;
        if (this.getSettingValue('general.collapseOnPCByDefault')) isCollapsePC = true;
        if (this.getSettingValue('general.collapseOnMobileByDefault')) isCollapseMobile = true;
        htmlElement.attr({ 'data-collapse-pc': isCollapsePC, 'data-collapse-mobile': isCollapseMobile });

        // Add attribute for The Search Box
        htmlElement.attr({
            'data-show-search-box-pc': showSearchBoxFilterPC,
            'data-show-search-box-mobile': showSearchBoxFilterMobile
        });

        // Add attribute for Show More
        if (showMoreType) htmlElement.attr({ 'data-show-more-type': showMoreType });

        // Add Currency next to Title of Price Range
        if (data.filterType == 'price' && data.displayType == 'range' && this.getSettingValue('general.rangeStyle') == 'style1')
            htmlElement.find('.' + this.class.filterBlockTitle).find('h3 > span').append(' <span>' + this.getCurrency() + '</span>');

        // Add attribute for AND condition
        if (data.hasOwnProperty('useAndCondition') && data.useAndCondition) htmlElement.attr('data-and-condition', true);

        // Add attribute for Exact Rating
        if(data.hasOwnProperty('showExactRating') && data.showExactRating) htmlElement.attr('data-exact-rating', true);

        // Add attribute for filter option data
        htmlElement.attr('data-filter-option', JSON.stringify(data));

        // Add Filter option to Filter tree
        this.addFilterTreeItem(jQ(htmlElement)[0].outerHTML, 'after', filterTreeId);

        // Hide Filter options
        if (!this.checkShowFilterOption(data)) jQ('.' + blockId).addClass(this.class.filterOptionHidden);
    }
};
/* Boost-End-42588 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */


BCSfFilter.prototype.scrollBackPositionHistoryBack = function() {
    
    if (this.getSettingValue("general.enableKeepScrollbackPosition")) {
        var a = jQ(this.selector.products).children();
        if (this.isAdvancedPaginationType() && a.length > 0) {
            var b = parseInt(this.queryParams.page);
            if (a.each(function() {
                    if (void 0 === jQ(this).attr("id")) {
                        var a = "";
                        jQ(this).find("a").each(function() {
                            var b = jQ(this).attr("href") || "";
                            if (b.length > 0 && b.match(/(?:\/products\/)(?:[^\?]*)/)) return a = b.split("?")[0], !1
                        });
                        var c = a.toString().replace(/^_+|_+$|\//g, "") + "-" + b;
                        jQ(this).attr("id", c)
                    }
                    
                    void 0 === jQ(this).data("page") && jQ(this).attr("data-page", b)
                }), this.isMobile()) {
                var c = !1;
                a.on("touchstart", function() {
                    c = !1
                }).on("touchmove", function(a) {
                    c = !0
                }).on("touchend", function(a) {
                    var b = jQ(this).attr("id") || !1;
                    if (b) {
                        var d = new URL(window.location.href),
                            e = jQ(this).data("page") || 1,
                            f = {
                                productId: b,
                                page: e
                            };
                        null !== d.searchParams.get("page") && d.searchParams.delete("page"), parseInt(e) > 1 && d.searchParams.append("page", e), window.history.replaceState(f, "", d.toString().replace(/\+/g, "%20"))
                    }
                })
            } else a.click(function(a) {
                var b = jQ(this).attr("id") || !1;
                console.log(b)
                if (b) {
                    var c = new URL(window.location.href),
                        d = jQ(this).data("page") || 1,
                        e = {
                            productId: b,
                            page: d
                        };
                    
                    null !== c.searchParams.get("page") && c.searchParams.delete("page"), parseInt(d) > 1 && c.searchParams.append("page", d), window.history.replaceState(e, "", c.toString().replace(/\+/g, "%20"))
                }
            });
            if (this.getSettingValue('general.paginationType') == 'infinite') {
                var d = new URL(window.location.href),
                e = history.state.productId;
                history.scrollRestoration = 'manual'
                null !== e && (window.history.replaceState("", "", d.toString().replace(/\+/g, "%20")), jQ("html, body").animate({
                    scrollTop: jQ("#" + e).offset().top - 100
                }, 0))
            }
        }
    }
}

BCSfFilter.prototype.optimizeImage = function(a, b) {
    null === a && (a = bcSfFilterConfig.general.no_image_url);
    for (var b = void 0 !== b ? b : "260x", c = this.getSettingValue("general.imageExtension"), d = 0; d < c.length; d++) a = a.replace("." + c[d] + "?", "_" + b + "." + c[d] + "?");
    return a
}
BCSfFilter.prototype.optimizeImageSmall = function(a, b) {
    null === a && (a = bcSfFilterConfig.general.no_image_url);
    for (var b = void 0 !== b ? b : "small", c = this.getSettingValue("general.imageExtension"), d = 0; d < c.length; d++) a = a.replace("." + c[d] + "?", "_" + b + "." + c[d] + "?");
    return a
}
BCSfFilter.prototype.buildToolbarEvent = function(a) {
    this.buildSortingEvent(), this.buildShowLimitEvent(), this.buildDisplayTypeEvent(), this.buildPaginationEvent(a)
}